import axios from 'axios';

export const RefferersService = {
  async getRefferers() {
    const res = await axios.get(`refferers/`);

    if (res) {
      return res.data;
    }

    return Promise.reject();
  },

  async getRefferersById(id) {
    const res = await axios.get(`refferers/${id}/`);

    if (res) {
      return res.data;
    }

    return Promise.reject();
  },

  async createRefferers(data) {
    const res = await axios.post('refferers/', data);

    if (res.status === 201) {
      return true;
    }

    return Promise.reject();
  },

  async deleteAppVersion(id) {
    const res = await axios.delete(`refferers/${id}/`);

    if (res.status === 200) {
      return true;
    }

    return Promise.reject();
  },

  async updateRefferers(id, data) {
    const res = await axios.put(`refferers/${id}/`, data);

    if (res.status === 200) {
      return true;
    }

    return Promise.reject();
  },
};
